import { render, staticRenderFns } from "./CmgBagGroupOrderDetails.vue?vue&type=template&id=34523592&scoped=true&lang=pug"
import script from "./cmg-bag-group-order-details.ts?vue&type=script&lang=ts&external"
export * from "./cmg-bag-group-order-details.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgBagGroupOrderDetails.vue?vue&type=style&index=0&id=34523592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34523592",
  null
  
)

export default component.exports